export default [
  'compareByDateSelected',
  'compareByViewRemovedDeals',
  'recycleBinCompareByLvClick',
  'recycleBinPermanentDelete',
  'recycleBinRestore'
]
